// extracted by mini-css-extract-plugin
module.exports = {"ModeratorInvitationListItem":"bcu_a bhv_a bhv_r bhv_j","ModeratorInvitationListItem__left":"bcu_b bhv_a bhv_j","ModeratorInvitationListItem__note":"bcu_c bhv_fi"};